import { enumObject, EnumObjectValue } from '@app/base';
import { CatalogCareHomeFragment, CatalogCareHomeLookupFragment } from './graphql';

export const CatalogCareHomeType = enumObject('CatalogCareHomeType', ['PHYSICAL', 'TELEHEALTH'] as const);
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type CatalogCareHomeType = EnumObjectValue<typeof CatalogCareHomeType>;

export const CatalogCareHomeStatus = enumObject('CatalogCareHomeStatus', ['ACTIVE', 'ARCHIVED'] as const);
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type CatalogCareHomeStatusValue = EnumObjectValue<typeof CatalogCareHomeStatus>;

export type CatalogCareHome = CatalogCareHomeFragment;
export type CatalogCareHomeLookup = CatalogCareHomeLookupFragment;

/** Fields returned by `GET /api/catalog-care-home/{id}` (REST), including contact fields not present on GraphQL list fragments. */
export type CatalogCareHomeDetail = CatalogCareHomeFragment & {
  phone: string | null;
  email: string | null;
  note: string | null;
};

export type PhysicalCatalogCareHome = Omit<CatalogCareHome, 'address'> & {
  address: NonNullable<CatalogCareHome['address']>;
};

export type PhysicalCatalogCareHomeDetail = Omit<CatalogCareHomeDetail, 'address' | 'type'> & {
  type: 'PHYSICAL';
  address: NonNullable<CatalogCareHomeDetail['address']>;
};

export function isPhysicalCatalogCareHomeDetail(
  loc: CatalogCareHomeDetail | null | undefined,
): loc is PhysicalCatalogCareHomeDetail {
  return loc != null && loc.type === 'PHYSICAL' && loc.address != null;
}

type AddCatalogCareHomeAddress = NonNullable<CatalogCareHome['address']> & {
  country: string;
};

export type AddCatalogCareHomeRequest = Pick<CatalogCareHome, 'name' | 'archived'> & {
  address: AddCatalogCareHomeAddress;
  providerId: string | null;
  phone: string | null;
  email: string | null;
  note: string | null;
};

type UpdateCatalogCareHomeAddress = AddCatalogCareHomeAddress;

export type UpdateCatalogCareHomeRequest = Omit<CatalogCareHome, 'providerId' | 'address'> & {
  address: UpdateCatalogCareHomeAddress;
  phone: string | null;
  email: string | null;
  note: string | null;
};

export interface DeleteCatalogCareHomeRequest {
  id: string;
}

export type ArchiveCatalogCareHomeRequest = DeleteCatalogCareHomeRequest;
